'use strict';

angular.module('shiftTraderApp')
  .directive('saAvailabilityBarBlock', ['$compile', '$timeout', 'TimeService', function ($compile, $timeout, TimeService) {

      var createTimeTemplateHTML = function(rule) {
        var startTimeHTML = TimeService.minutesToTimeString(rule.start_time_minutes, true, true);
        var endTimeHTML = TimeService.minutesToTimeString(rule.end_time_minutes, true, true);

        return startTimeHTML + '<span class="separator">-</span>' + endTimeHTML;
      };

      var getTemplate = function(rule, isEditable) {
          return '<div class="availability_block">' +
          '<div class="availability_block_text">' +
            createTimeTemplateHTML(rule) +
              (isEditable ? ('<div class="remove_block" data-ng-click="removeRule()">' +
              '<i class="icon-remove pointer"></i>' +
            '</div>') : '') +
          '</div>' +
          '</div>';
      };

      return {
        restrict: 'EA',
        replace: true,
        scope: {
          rule: '=saAvailabilityBarBlock',
          editable: '@',
          eventIdentifier: '@'
        },
        link: function postLink(scope, element) {
          var timeout;
          scope.isEditable = (scope.editable === 'true' || scope.editable === true);

          var render = function() {
            var styling = {
                left: scope.rule.start_time_minutes / 1440.0 * 100 + '%',
                width: ((scope.rule.end_time_minutes - scope.rule.start_time_minutes) / 1440.0) * 100 + '%',
                'z-index': 10 - scope.$parent.$index
            };
            element.html($compile(getTemplate(scope.rule, scope.isEditable))(scope));

            var availabilityBlock = element.find('.availability_block');
            availabilityBlock.css(styling);

            if(scope.rule.avail) {
              availabilityBlock.addClass('available');
            } else {
              availabilityBlock.addClass('unavailable');
            }

            if (timeout) {
              $timeout.cancel(timeout);
            }

            if (scope.isEditable) {
              timeout = $timeout(function() {
                angular.element(element).hover(function() {
                  var rb = angular.element(this).find('.remove_block');
                  rb.show();
                  rb.on('click', function() {
                    angular.element(this).addClass('clicked');
                    setTimeout(function() {
                      rb.removeClass('clicked');
                    }, 300);
                  });
                }, function() {
                  var rb = angular.element(this).find('.remove_block');
                  rb.hide();
                });
              }, 500);
            }
          };
          render();

          scope.removeRule = function() {
            console.log('emitting event: ', 'availabilitySet:' + scope.eventIdentifier + ':removal');
            console.log(scope.rule);
            scope.$emit('availabilitySet:' + scope.eventIdentifier + ':removal', scope.rule);
          }
        }
      };
  }]);
